export const senecStepperTheme = {
    styleOverrides: {
        root: {
            alignItems: "flex-start",
            margin: "0 1.5rem 4rem 1.5rem !important",
        },
    },
};
